<template>
  <div class="page with-navbar with-page-footer" id="myCenter" style="height:100%;overflow:auto">
    <div class="profile-wrap">
      <div class="user-avatar" @click="bindToProfile">
        <img v-if="myInfo.headimgurl" :src="myInfo.headimgurl" alt="" />
        <img v-else src="~@static/fundingnew/register/avatar-default.png" alt="" />
      </div>
      <div class="nick-name" v-if="myInfo.nickname">{{myInfo.nickname}}</div>

      <div class="link-btn--lg btn-gallay" @click="bindToGallery">
        <button class="button pink-circle-btn icon">
          <div class="btn-inner">
            <div class="text">我的照片墙</div>
          </div>
        </button>
      </div>

      <div class="about-me">
        <img class="title-about" src="~@static/fundingnew/profile/title-about.png" alt="" />
        <div class="tab-bar-list">
          <div v-for="(item, index) in tabList" :key="index" class="tab-bar-item"
            :class="{ active: item.ID == seletedId }" @click="handleClickTab(item.ID)">
            {{ item.Name }}
          </div>
        </div>

        <!-- list -->
        <div class="project-list-container">
          <template v-if="seletedId == 1">
            <div class="project-list" v-if="likeList.length">
              <div v-for="item of likeList" :key="item.id" class="project-item-box">
                <project-item-my :projectData="item"></project-item-my>
              </div>
              <div class="link-btn--lg btn-explore-end">
                <button class="button pink-circle-btn icon" @click="bindToOthers">
                  <div class="btn-inner">
                    <div class="text">看看新鲜夜计划</div>
                  </div>
                </button>
              </div>
              <!-- <div class="loadMore-s2" v-if="hasMoreData" @click="loadMore"><span>查看更多</span></div> -->
            </div>
            <div class="link-btn--lg btn-explore" v-else>
              <button class="button pink-circle-btn icon" @click="bindToOthers">
                <div class="btn-inner">
                  <div class="text">看看新鲜夜计划</div>
                </div>
              </button>
            </div>
          </template>
          <template v-if="seletedId == 2">
            <div class="project-list" v-if="applyList.length">
              <div v-for="item of applyList" :key="item.id" class="project-item-box">
                <project-item-my :projectData="item" :isJoin="true"></project-item-my>
              </div>
              <div class="link-btn--lg btn-explore-end">
                <button class="button pink-circle-btn icon" @click="bindToCalendar">
                  <div class="btn-inner">
                    <div class="text">查看夜计划日历</div>
                  </div>
                </button>
              </div>
            </div>
            <div class="link-btn--lg btn-explore" v-else>
              <button class="button pink-circle-btn icon" @click="bindToCalendar">
                <div class="btn-inner">
                  <div class="text">查看夜计划日历</div>
                </div>
              </button>
            </div>
          </template>
          <template v-if="seletedId == 3">
            <div class="project-list" v-if="myPlanList.length">
              <div v-for="item of myPlanList" :key="item.id" class="project-item-box">
                <project-item-my :projectData="item"></project-item-my>
              </div>
              <div class="link-btn--lg btn-explore-end">
                <button class="button pink-circle-btn icon" @click="bindToOthers">
                  <div class="btn-inner">
                    <div class="text">看看别人的</div>
                  </div>
                </button>
              </div>
            </div>
            <div class="link-btn--lg btn-explore" v-else>
              <button class="button pink-circle-btn icon" @click="bindToOthers">
                <div class="btn-inner">
                  <div class="text">看看别人的</div>
                </div>
              </button>
            </div>
          </template>
        </div>
        <div class="scroll-top-s2" @click="scrollToTop">
          <img src="~@static/funding/icon-top.png" />
        </div>

        <!-- 遮罩 -->
        <template v-if="isShowHint">
          <div class="mask"></div>
          <div class="pop-guid-img">
            <img src="~@static/fundingnew/profile/pop-guide.png" alt="" />
          </div>
        </template>
      </div>

    </div>
    <rebuild-nav-bar></rebuild-nav-bar>
    <!-- <page-footer></page-footer> -->
  </div>
</template>

<script>
// import TopBar from '@components/TopBar'
import PageFooter from '@components/PageFooter'
import RebuildNavBar from '@components/RebuildNavBar'
import ProjectItemMy from '../components/ProjectItemMy'
import { mapState, mapMutations } from 'vuex'
import { verify, tools } from '@/utils'
import { behavior } from '@/utils/behavior'

export default {
  name: 'ProfileIndex',
  components: {
    // TopBar,
    PageFooter,
    RebuildNavBar,
    ProjectItemMy,
  },
  data() {
    return {
      isShowHint: false,
      seletedId: 1,
      avatarUrl: '',
      nickName: '',
      likeList: [],
      applyList: [],
      myPlanList: [],
      tabList: [
        {
          ID: 1,
          Name: '赞',
        },
        {
          ID: 2,
          Name: '已报名',
        },
        {
          ID: 3,
          Name: '我的夜计划',
        },
      ],
      myInfo: {
        nickname: '',
        headimgurl: '',
      },
    }
  },
  computed: {
    ...mapState(['authorization', 'nickname', 'profileVisitCount']),
  },
  mounted() {
    let n = parseInt(this.profileVisitCount)
    if (isNaN(n)) {
      this.profileVisitCount = 0
    }
    if (n === 0 || n < 3) {
      this.isShowHint = true
      this.setProfileVisitCount(n + 1)
      setTimeout(() => {
        this.isShowHint = false
      }, 4000)
    } else {
      this.isShowHint = false
    }
    this.getProfile()
    this.requestLikes()
    this.requestMyPlans()
    this.requestCalendar()

    // 分享
    if (verify.isWeixin()) {
      let shareInfo = {
        title: '绝对夜计划',
        desc: '绝对赛博夜计划，最高赢取5万元派对金，邀你一起造',
        imgUrl: this.$apiConfig.domain + '/static/funding_cpunk/share.png?v=1',
      }
      let p = tools.parseParams(this.$route.query)
      this.WXConfig.wxShowMenu(`${this.$apiConfig.domain}/welcome?${p}`, shareInfo)
    }
  },
  methods: {
    ...mapMutations(['setProfileVisitCount']),
    getProfile: function () {
      const _self = this
      this.$request
        .get(this.$apiConfig.myProfile)
        .then(res => {
          const resData = res.data
          if (resData.code == 0 && resData.data) {
            let d = resData.data
            this.myInfo.nickname = d.nickname
            this.myInfo.headimgurl = d.headimgurl
          } else {
            console.log(res.msg)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    handleClickTab(id) {
      this.seletedId = id
      if (id === 1) {
        _jcq.push(['_track', 'my_like'])
        behavior({ behavior_code: 'prc_bhv_abs_personalcenter_bc4' })
      }
      if (id === 2) {
      }
      if (id === 3) {
        _jcq.push(['_track', 'my_yjihua'])
        behavior({ behavior_code: 'prc_bhv_abs_personalcenter_bc5' })
      }
    },
    requestLikes() {
      this.$request.get(this.$apiConfig.myLikePlans, { params: { page: 1, per_page: 50 } }).then(res => {
        let resCode = res.data
        if (resCode.code == 0) {
          this.likeList = resCode.data.items
        }
      })
    },
    requestMyPlans() {
      this.$request.get(this.$apiConfig.myPlans, { params: { page: 1, per_page: 50 } }).then(res => {
        let resCode = res.data
        if (resCode.code == 0) {
          this.myPlanList = resCode.data.items
        }
      })
    },
    requestCalendar() {
      this.$request.get(this.$apiConfig.myJoinPlansUrl, { params: { page: 1, per_page: 50 } }).then(res => {
        let resCode = res.data
        if (resCode.code == 0) {
          this.applyList = resCode.data.items
        }
      })
    },
    bindToCalendar() {
      _jcq.push(['_track', 'mycalendar_click'])
      behavior({ behavior_code: 'prc_bhv_abs_personalcenter_bc9' })
      this.$router.push('/fundingnew/calendar')
    },
    bindToProfile() {
      this.$router.push('/fundingnew/my/profile?profile_from=center')
    },
    bindToOthers() {
      this.$router.push('/fundingnew/explore')
      _jcq.push(['_track', 'my_newyjihua'])
      behavior({ behavior_code: 'prc_bhv_abs_personalcenter_bc8' })
    },
    bindToGallery() {
      this.$router.push('/fundingnew/my/gallery/list')
      _jcq.push(['_track', 'my_ugc'])
      behavior({ behavior_code: 'prc_bhv_abs_personalcenter_bc3' })
    },
    toLogin() {
      this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
    },
    scrollToTop: function (e) {
      document.querySelector('#myCenter').scrollTop = 0
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@styles/v2-common.scss';
.profile-wrap {
  position: relative;
  padding-top: pxtow(100);
}

.user-avatar {
  width: pxtow(200);
  height: pxtow(200);
  margin: 0 auto;
  border-radius: 50%;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}

.nick-name {
  font-size: pxtow(36);
  font-weight: bold;
  font-family: 'Absolut-Bold';
  color: #fff;
  line-height: 1;
  margin-top: pxtow(42);
  text-align: center;
}

.pop-guid-img {
  position: absolute;
  width: pxtow(412);
  height: pxtow(200);
  top: pxtow(100);
  left: 50%;
  transform: translateX(pxtow(-100));
  z-index: 10000;
  img {
    max-width: 100%;
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(#000, 0.65);
}

.link-btn--lg {
  text-align: center;
  &.btn-gallay {
    margin-top: pxtow(48);
  }
  &.btn-explore {
    margin-top: pxtow(220);
    margin-bottom: pxtow(140);
  }
  &.btn-explore-end {
    margin-top: pxtow(90);
  }
}

.about-me {
  margin-top: pxtow(52);
  .title-about {
    width: pxtow(200);
    height: pxtow(63);
    margin-left: pxtow(36);
  }
}

.tab-bar-list {
  margin-top: pxtow(30);
  padding-left: pxtow(30);
  padding-right: pxtow(30);
  .tab-bar-item {
    display: inline-block;
    font-size: pxtow(28);
    font-family: 'Absolut-Bold';
    color: #fff;
    padding: pxtow(5) pxtow(20);
    font-weight: 700;
    &.active {
      color: #a92198;
    }
  }
}
.project-list-container {
  margin: pxtow(20) pxtow(50) 0;
  .project-item-box {
    margin-top: pxtow(50);
    &:first-child {
      margin-top: 0;
    }
  }
}

// .zao-party-list {
//   margin-top: pxtow(27);
//   padding-left: pxtow(50);
//   padding-right: pxtow(50);
//   .zao-party-item {
//     .zao-party-inner {
//       display: flex;
//     }
//     & + .zao-party-item {
//       margin-top: pxtow(52);
//     }
//     .zao-party-img {
//       width: pxtow(288);
//       height: pxtow(288);
//       border-radius: pxtow(16);
//     }
//     .zao-party-content {
//       position: relative;
//       flex: 1;
//       align-self: center;
//       color: #fff;
//       min-width: 0;
//       height: pxtow(255);
//       padding: pxtow(30) pxtow(32); //pxtow(40)
//       border-radius: 0 pxtow(16) pxtow(16) 0;
//       background: rgba($darkblue, 0.5);
//       .go-detail-btn {
//         position: absolute;
//         right: pxtow(-15);
//         bottom: pxtow(-32);
//         width: pxtow(162);
//         height: pxtow(64);
//       }
//     }
//     .title {
//       font-size: pxtow(48);
//       font-family: "Absolut-Bold";
//       text-overflow: ellipsis;
//       white-space: nowrap;
//       overflow: hidden;
//     }
//     .desc {
//       margin-top: pxtow(4);
//       // margin-top: pxtow(12);
//       font-size: pxtow(27);
//       font-weight: bold;
//       font-family: "Absolut-Bold";
//       text-overflow: ellipsis;
//       white-space: nowrap;
//       overflow: hidden;
//     }
//     .location {
//       margin-top: pxtow(8);
//       // margin-top: pxtow(22);
//       font-size: pxtow(22);
//       text-overflow: ellipsis;
//       white-space: nowrap;
//       overflow: hidden;
//       line-height: 1;
//       .img-icon-loction {
//         display: inline-block;
//         background-image: url("~@static/fundingnew/profile/icon-location.png");
//         background-repeat: no-repeat;
//         background-size: pxtow(22) pxtow(22);
//         width: pxtow(22);
//         height: pxtow(22);
//         margin-right: pxtow(8);
//       }
//     }
//     .like {
//       margin-top: pxtow(8);
//       // margin-top: pxtow(12);
//       font-size: pxtow(22);
//       line-height: 1;
//       .img-icon-like {
//         display: inline-block;
//         background-image: url("~@static/fundingnew/profile/icon-like.png");
//         background-repeat: no-repeat;
//         background-size: pxtow(22) pxtow(22);
//         width: pxtow(22);
//         height: pxtow(22);
//         margin-right: pxtow(8);
//       }
//     }
//     .zao-party-tags {
//       margin-top: pxtow(52);
//       .zao-party-tag {
//         display: inline-block;
//         min-width: pxtow(172);
//         padding: 0 pxtow(10);
//         height: pxtow(58);
//         margin-right: pxtow(18);
//         line-height: pxtow(58);
//         font-size: pxtow(28);
//         color: #fff;
//         text-align: center;
//         border-radius: pxtow(26);
//         border: 1px solid #fff;
//       }
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/my/Submissions.vue